<template lang="pug">
a.tab.flex_v.align-items-center.justify-content-center(
  :href="tab.area01_ProductURL",
  style="cursor: pointer",
  target="_blank"
)
  img(:src="tab.area01_ProductIcon")
  p {{ tab.area01_ProductName }}
</template>

<script>
export default {
  name: "Tab",
  props: {
    tab: Object,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/tab";
</style>
